const UID_KEY = 'superoti.device_uid'

function createUid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }
  return `dev-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

export function getOrCreateDeviceUid(): string {
  const existing = localStorage.getItem(UID_KEY)
  if (existing) return existing
  const uid = createUid()
  localStorage.setItem(UID_KEY, uid)
  return uid
}

/** Hapus fingerprint perangkat — dipakai saat Ganti device agar aktivasi ulang tidak bentrok device lama di server. */
export function clearDeviceUid(): void {
  localStorage.removeItem(UID_KEY)
}

/** Ringkas untuk kolom device.os (max 64 char di backend). */
export function getDeviceOs(): string {
  const raw = navigator.platform?.trim() || 'web'
  return raw.slice(0, 64)
}
